import { ScreenState as e } from "../screen-state/index.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
import { ErrorBoundary as n } from "react-error-boundary";
// src/design/error-boundary/index.tsx
var r = ({ error: n, reset: r }) => {
	let i = n instanceof Error ? n.message : String(n);
	return console.error("React Error Boundary error", i), /* @__PURE__ */ t(e.Error, {
		description: "Try again. If it keeps happening, contact your administrator.",
		onRetry: r
	});
}, i = ({ error: e, resetErrorBoundary: n }) => /* @__PURE__ */ t(r, {
	error: e,
	reset: n
}), a = ({ children: e }) => /* @__PURE__ */ t(n, {
	FallbackComponent: i,
	children: e
}), o = (e) => (n) => /* @__PURE__ */ t(a, { children: /* @__PURE__ */ t(e, { ...n }) });
export { a as ErrorBoundary, a as default, r as RouteError, o as withErrorBoundary };

//# sourceMappingURL=index.js.map